import { LegalityChecker, DeckLeglaity } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const totalDeckPoints = deck.mainboard.reduce((points, card) => points + (card.canlanderPoints || 0), 0)

  if (totalDeckPoints > 10) deck.addError(ERRORS.OVER_MAX_POINTS_CANLANDER)

  for (const card of deck.mainboard) {
    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 1)
  }

  if (deck.deckSize < 100) deck.addError(ERRORS.CANLANDER_DECKSIZE)
}

export default CheckLegality
